import {
  MonitoringEventRule,
  EventNotification,
  MONITORING_EVENT_TYPE_CD,
} from "./monitoring-event-rule";

const CONTACT_TYPE_CD = {
  OFF: "0",
  ON: "1",
};

/* eslint-disable no-unused-expressions */
class ContactMonitoringEventRule extends MonitoringEventRule {
  constructor(monitoringTargetId, monitoringEventRuleId = null) {
    super(monitoringTargetId, monitoringEventRuleId);

    this._monitoringEventTypeCd = MONITORING_EVENT_TYPE_CD.CONTACT;
    this._monitoringDeviceId;
    this._contactTypeCd = CONTACT_TYPE_CD.ON;
    this._eventStartNotification = new EventNotification();
    this._eventEndNotification = new EventNotification();
  }

  get monitoringDeviceId() {
    return this._monitoringDeviceId;
  }

  set monitoringDeviceId(value) {
    this._monitoringDeviceId = value;
  }

  get contactTypeCd() {
    return this._contactTypeCd;
  }

  set contactTypeCd(value) {
    this._contactTypeCd = value;
  }

  get eventStartNotification() {
    return this._eventStartNotification;
  }

  set eventStartNotification(value) {
    this._eventStartNotification = value;
  }

  get eventEndNotification() {
    return this._eventEndNotification;
  }

  set eventEndNotification(value) {
    this._eventEndNotification = value;
  }

  json() {
    const res = super.json();
    Object.assign(res, {
      config: {
        contactTypeCd: this.contactTypeCd,
        eventStartNotification: this.eventStartNotification.json(),
        eventEndNotification: this.eventEndNotification.json(),
      },
    });
    return res;
  }

  copy() {
    const monitoringEventRule
      = new ContactMonitoringEventRule(this.monitoringTargetId, this.monitoringEventRuleId);
    monitoringEventRule.copyProperties(this);
    return monitoringEventRule;
  }

  copyProperties(monitoringEventRule) {
    super.copyProperties(monitoringEventRule);

    this.monitoringDeviceId = monitoringEventRule.monitoringDeviceId;
    this.contactTypeCd = monitoringEventRule.contactTypeCd;
    this.eventStartNotification = monitoringEventRule.eventStartNotification.copy();
    this.eventEndNotification = monitoringEventRule.eventEndNotification.copy();
  }

  getApiRequestJson() {
    const requestJosn = super.getApiRequestJson();

    Object.assign(requestJosn, {
      config: {
        contact_type_cd: this.contactTypeCd,
        event_start_notification: this.eventStartNotification.getApiRequestJson(),
        event_end_notification: this.eventEndNotification.getApiRequestJson(),
      },
    });

    // 監視デバイスの指定がある場合は、リクエストパラメータを追加
    if (this.monitoringDeviceId !== null) {
      requestJosn.config.monitoring_device_id = this.monitoringDeviceId;
    }
    return requestJosn;
  }

  setApiResponseJosn(item) {
    super.setApiResponseJosn(item);
    this.contactTypeCd = item.config.contact_type_cd;
    this.monitoringDeviceId = item.config.monitoring_device_id;

    const eventStartNotification = new EventNotification();
    if (item.config.event_start_notification) {
      eventStartNotification.statusCd = item.config.event_start_notification.status_cd;
      eventStartNotification.title = item.config.event_start_notification.title;
    }
    this.eventStartNotification = eventStartNotification;

    const eventEndNotification = new EventNotification();
    if (item.config.event_end_notification) {
      eventEndNotification.statusCd = item.config.event_end_notification.status_cd;
      eventEndNotification.title = item.config.event_end_notification.title;
    }
    this.eventEndNotification = eventEndNotification;
  }

  contactTypeText() {
    let res = "";
    if (this.contactTypeCd === CONTACT_TYPE_CD.ON) {
      res = "接点がONになったとき";
    } else if (this.contactTypeCd === CONTACT_TYPE_CD.OFF) {
      res = "接点がOFFになったとき";
    }
    return res;
  }
}
/* eslint-enable */

export {
  CONTACT_TYPE_CD,
  ContactMonitoringEventRule,
};
